import { render, staticRenderFns } from "./sparePart.vue?vue&type=template&id=1da0215c&scoped=true&"
import script from "./sparePart.vue?vue&type=script&lang=js&"
export * from "./sparePart.vue?vue&type=script&lang=js&"
import style0 from "./sparePart.vue?vue&type=style&index=0&id=1da0215c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da0215c",
  null
  
)

export default component.exports